import { render, staticRenderFns } from "./ContabilitaRiepilogoComponent.vue?vue&type=template&id=b095c37e&scoped=true"
import script from "./ContabilitaRiepilogoComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaRiepilogoComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaRiepilogoComponent.vue?vue&type=style&index=0&id=b095c37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b095c37e",
  null
  
)

export default component.exports